import { render, staticRenderFns } from "./content.vue?vue&type=template&id=0121eac6&"
import script from "./content.vue?vue&type=script&lang=js&"
export * from "./content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./content-i18n.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fweb%2Fsrc%2Fviews%2Fbackoffice%2Ftasks%2Flist%2Fbo-ready-for-sap-export%2Fcontent.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports